import { examDateRows } from "../../lib/examSchedules.js";

export function gradeOptions(level) {
  const count = ["elementary", "초등"].includes(level)
    ? 6
    : ["middle", "high", "중등", "고등"].includes(level)
    ? 3
    : 0;
  return Array.from(
    { length: count },
    (_, i) => ({ value: String(i + 1), label: `${i + 1}학년` }),
  );
}
export function shiftExamDate(date, amount) {
  examDateRows(date, date);
  const result = new Date(`${date}T00:00:00Z`);
  result.setUTCDate(result.getUTCDate() + amount);
  const key = result.toISOString().slice(0, 10);
  examDateRows(key, key);
  return key;
}
export function examPlan(form, date) {
  const value = form.subjects?.[date];
  return typeof value === "string"
    ? { subject: value, direct: "" }
    : { subject: value?.subject || "", direct: value?.direct || "" };
}
export function actualExamRange(form) {
  const dates = examDateRows(form.inputStart, form.inputEnd);
  return { start: dates[0] || null, end: dates.at(-1) || null };
}
export function changeExamRange(form, start, end) {
  const dates = examDateRows(start, end);
  const kept = new Set(dates);
  const removedInputs = examDateRows(form.inputStart, form.inputEnd).filter(
    (date) => {
      const plan = examPlan(form, date);
      return !kept.has(date) && !!(plan.subject.trim() || plan.direct.trim());
    },
  );
  return {
    removedInputs,
    form: {
      ...form,
      inputStart: start,
      inputEnd: end,
      subjects: Object.fromEntries(
        dates.map((
          date,
        ) => [date, form.subjects?.[date] ?? { subject: "", direct: "" }]),
      ),
    },
  };
}
export function extendExamForm(form, edge) {
  const date = shiftExamDate(
    edge === "first" ? form.inputStart : form.inputEnd,
    edge === "first" ? -1 : 1,
  );
  return {
    ...form,
    [edge === "first" ? "inputStart" : "inputEnd"]: date,
    subjects: { ...form.subjects, [date]: { subject: "", direct: "" } },
  };
}
export function removeExamEdge(form, date) {
  if (
    form.inputStart === form.inputEnd ||
    ![form.inputStart, form.inputEnd].includes(date)
  ) return form;
  const subjects = { ...form.subjects };
  delete subjects[date];
  return {
    ...form,
    inputStart: date === form.inputStart
      ? shiftExamDate(date, 1)
      : form.inputStart,
    inputEnd: date === form.inputEnd ? shiftExamDate(date, -1) : form.inputEnd,
    subjects,
  };
}
